import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { Transaction, TransactionRequest, TransactionResponse } from './types'

export const changedDateFormat = (date: Date) =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

const DATE_FIELDS = ['updatedAt', 'createdAt']

const mapSearchEntry = (key: string, value: any): [string, any] => {
  if (key === 'transactionId') {
    return ['id', value?.toLowerCase()]
  }

  if (DATE_FIELDS.includes(key)) {
    const dates = Array.isArray(value)
      ? value.map((date) => (date ? changedDateFormat(date?.$d) : `${date}`))
      : value
    return [key, dates]
  }

  return [key, value?.toLowerCase()]
}

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map(([key, value]) =>
      mapSearchEntry(key, value),
    ),
  )
}

const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}

export const transactionsListMounted = createEvent<TransactionRequest>()

export const getTransactions = fx<TransactionRequest, TransactionResponse>({
  method: 'GET',
  url: `/transaction_request`,
})

export const $transactions = restore<Transaction[]>(
  getTransactions.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfTransactions = restore(
  getTransactions.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: transactionsListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText, filters }) => {
    if (orderDirection == 'descend') {
      orderDirection = '-'
    } else if (orderDirection == 'ascend') {
      orderDirection = ''
    }
    if (orderBy == 'transactionId') {
      orderBy = 'id'
    }
    let query = {
      limit,
      page,
    }
    // @ts-ignore
    if (orderBy != '') {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }
    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            key === 'status' ||
            key === 'direction' ||
            key === 'product' ||
            key === 'initialCurrency' ||
            key === 'clientCurrency'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      if (Object.keys(newObj).length) {
        // @ts-ignore
        query['where'] = `${JSON.stringify(newObj)}`
      }
    }

    return {
      query,
    }
  },
  target: getTransactions,
})
